import React from 'react';

export const VerifyEmailPage = React.lazy(() => import('./VerifyEmailPage'));
